import React, { Suspense } from 'react';
import Loader from 'components/Loader';
import { Routes, Route as ReactRoute } from 'react-router-dom';
import Route from './Route';
import useApp from './useApp';
import { pages } from './pages';
import isAllowedTo from 'utils/isAllowedTo';

const SignIn = React.lazy(() => import('pages/SignIn'));
// const Dashboard = React.lazy(() => import('pages/Dashboard'));

export default function AppRoutes() {
  useApp();

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <ReactRoute path="/" element={<SignIn />} />
        {pages
          .filter(({ permissions }) => isAllowedTo(permissions))
          .map(({ path, element }) => {
            const Component = element;
            return <Route key={path} path={path} element={<Component />} />;
          })}
      </Routes>
    </Suspense>
  );
}
